<style>
.bunding-account-safe .el-dialog__header {
    padding: 0;
}
.bunding-account-safe .el-tabs__item.is-active {
    color: #4990e2;
}
.bunding-account-safe .el-tabs__active-bar {
    background-color: #4990e2;
}
.bunding-account-safe .remind {
    font-size: 14px;
    color: #333333;
}
.bunding-account-safe .remind .tx {
    font-size: 12px;
    color: #d0011b;
    display: inline-block;
    margin-left: 20px;
}
.bunding-account-safe .bombbox {
    border-radius: 10px;
    width: 100%;
    padding: 0 15px;
}
.bunding-account-safe .input-form {
    margin-top: 20px;
    padding: 0px;
}
@media (min-width: 768px) {
    .bunding-account-safe .bombbox {
        width: 410px;
    }
    .bunding-account-safe .input-form {
        margin-top: 20px;
        padding: 0 50px;
    }
}
.bunding-account-safe .yan-zh {
    width: 126px;
    margin-right: 20px;
}
.bunding-account-safe .error-remind {
    padding-left: 50px;
    font-size: 14px;
    color: #d0011b;
}
.bunding-account-safe .que-button {
    width: 78px;
    height: 36px;
    color: #ffffff;
}
.bunding-account-safe .submit {
    text-align: center;
}
</style>
<template>
    <div class="bunding-account-safe">
        <el-dialog
            :visible="myResult"
            :close-on-click-modal=false
            :show-close=false
            label-width="0px"
            custom-class="bombbox"
        >
            <div
                slot="title"
                class="header"
            ></div>
            <el-tabs
                v-model="activeName"
                type="card"
            >
                <el-tab-pane
                    label="完善账户信息"
                    name="1"
                >
                    <div class="remind">账号设置<span class="tx">设置登录密码</span></div>
                    <el-form
                        :model="form1"
                        ref="form1"
                        class="input-form"
                        :rules="from1_rules"
                    >
                        <!--<el-form-item prop="account">-->
                        <!--<el-input v-model="form1.account" placeholder="设置账号"></el-input>-->
                        <!--</el-form-item>-->
                        <el-form-item prop="pwd">
                            <el-input
                                v-model="form1.pwd"
                                type="password"
                                placeholder="设置密码"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="c_pwd">
                            <el-input
                                v-model="form1.c_pwd"
                                type="password"
                                placeholder="确认密码"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane
                    label="绑定已有账户"
                    name="2"
                >
                    <div class="remind">账号绑定<span class="tx">绑定已有账号，确保账号正确</span></div>
                    <el-form
                        :model="form2"
                        ref="form2"
                        class="input-form"
                        :rules="from2_rules"
                    >
                        <el-form-item prop="account">
                            <el-input
                                v-model="form2.account"
                                placeholder="绑定已有账号"
                            ></el-input>
                        </el-form-item>
                        <el-form-item prop="pwd">
                            <el-input
                                v-model="form2.pwd"
                                type="password"
                                placeholder="密码"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
                <div class="remind remind2">安全验证<span class="tx">输入考生真实信息，保障账户安全</span></div>
                <el-form
                    :model="form3"
                    ref="form3"
                    class="input-form"
                    :rules="from3_rules"
                >
                    <el-form-item prop="name">
                        <el-input
                            v-model="form3.name"
                            placeholder="请填写证件上的真实姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="t_ct">
                        <el-select
                            filterable
                            v-model="form3.t_ct"
                            placeholder="证件类型"
                            style="width: 100%"
                        >
                            <el-option
                                v-for="CertType in CertTypes"
                                :key="CertType.value"
                                :label="CertType.label"
                                :value="CertType.value"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item prop="ct">
                        <el-input
                            v-model="form3.ct"
                            placeholder="请填写证件号,注册完成无法修改"
                        ></el-input>
                    </el-form-item>
                </el-form>
                <div
                    class="error-remind"
                    v-if="error_display"
                >
                    {{error_message}}
                </div>
                <div class="submit">
                    <el-button
                        type="primary"
                        class="que-button"
                        @click="postUserInform"
                    >确定</el-button>
                </div>
            </el-tabs>
        </el-dialog>
    </div>
</template>
<script type="text/ecmascript-6">
export default {
    data: function() {
        var validatePass = (rule, value, callback) => {
            this.error_display = false;
            if (value == "") {
                callback(new Error("请输入密码"));
            } else if (value.length < 6 && value.length > 26) {
                callback(new Error("请输入6-26位数字或字母"));
            } else {
                if (this.form1.c_pwd != "") {
                    this.$refs.form1.validateField("c_pwd");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value == "") {
                callback(new Error("请再次确认密码"));
            } else if (value != this.form1.pwd) {
                callback(new Error("确认密码输入有误，请重新输入!"));
            } else {
                callback();
            }
        };
        var validateCt = (rule, value, callback) => {
            this.error_display = false;
            if (value == "") {
                callback(new Error("请输入证件号码"));
            } else if (this.form3.t_ct == "") {
                callback(new Error("请选择一项证件类型!"));
            } else if (
                this.getStringSite(this.CertTypes, this.form3.t_ct) == 0
            ) {
                if (value.length == 18) {
                    if (this.$common.validateChinaCt(value)) {
                        callback();
                    } else {
                        //暂不判断最后一个校验码
                        callback(new Error("请输入正确的身份证信息!"));
                    }
                } else {
                    callback(new Error("请输入正确的身份证信息!"));
                }
            } else if (this.form3.t_ct == "32a4ea6ecd488590c74d875117219253") {
                //验证香港通行证
                if (this.$common.validateHongKongPass(value)) {
                    callback();
                } else {
                    //暂不判断最后一个校验码
                    callback(new Error("请输入正确的身份证信息!"));
                }
            } else if (this.form3.t_ct == "3c266df9007037d94c632875e066f488") {
                //验证台湾通行证
                if (this.$common.validateTaiWanPass(value)) {
                    callback();
                } else {
                    //暂不判断最后一个校验码
                    callback(new Error("请输入正确的身份证信息!"));
                }
            } else if (
                this.getStringSite(this.CertTypes, this.form3.t_ct) != 0
            ) {
                callback();
            }
        };
        var validatePass3 = (rule, value, callback) => {
            this.error_display = false;
            if (value == "") {
                callback(new Error("请输入密码"));
            } else {
                callback();
            }
        };
        //            var validateAccount = (rule, value, callback) => {
        //                this.error_display = false;
        //                if (value == '') {
        //                    callback(new Error('请输入账号'));
        //                }
        //                else if (this.error_msg == 'EA_NACIA_CI_02') {
        //                    callback(new Error(getErrorMessage(this.error_msg)));
        //                    this.error_msg = '';
        //                }
        //                else {
        //                    if (value.length <= 26 && value.length >= 6) {
        //                        let pattern = /^[A-Za-z]{1}[A-Za-z0-9_]{5,25}$/;
        //                        if (pattern.test(value)) {
        //                            callback()
        //                        }
        //                        else {
        //                            callback(new Error('账号错误，请输入6-26数字或字母'));
        //                        }
        //                    }
        //                    else {
        //                        callback(new Error('请输入6-26数字或字母'));
        //                    }
        //                }
        //            };
        return {
            error_msg: "",
            activeName: "1",
            CertTypes: "",
            error_display: false,
            error_message: "",
            form1: {
                account: "",
                pwd: "",
                c_pwd: ""
            },
            form2: {
                account: "",
                pwd: ""
            },
            form3: {
                name: "",
                t_ct: "",
                ct: ""
            },
            from1_rules: {
                //                    account: [
                //                        {required: true, validator: validateAccount, trigger: 'blur'},
                //                    ],
                pwd: [
                    { required: true, validator: validatePass, trigger: "blur" }
                ],
                c_pwd: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigger: "blur"
                    }
                ]
            },
            from2_rules: {
                account: [
                    { required: true, message: "请输入账号", trigger: "change" }
                ],
                pwd: [
                    {
                        required: true,
                        validator: validatePass3,
                        trigger: "blur"
                    }
                ]
            },
            from3_rules: {
                name: [
                    {
                        required: true,
                        message: "请输入真实姓名",
                        trigger: "change"
                    }
                ],
                t_ct: [
                    {
                        required: true,
                        message: "请选择一种证件类型",
                        trigger: "change"
                    }
                ],
                ct: [{ required: true, validator: validateCt, trigger: "blur" }]
            },
            myResult: this.dialogFormVisible,
            batchCode: this.$store.state.examInfo.currentExamInfo.batchCode
        };
    },
    props: {
        dialogFormVisible: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        dialogFormVisible(val) {
            this.myResult = val;
        },
        myResult(val) {
            this.$emit("on-result-change", val);
        },
        activeName(val) {
            this.error_display = false;
            if (this.$refs.form1 != null) this.$refs.form1.resetFields();
            if (this.$refs.form2 != null) this.$refs.form2.resetFields();
        }
    },
    created: function() {
        if (
            this.$store.state.common.token != null &&
            this.$store.state.common.certType == null
        ) {
            this.$http
                .get(globalProvider.serviceUrl("pc/g/ctn/{domain}"), {
                    params: {
                        domain:
                            this.$route.name == "main" ||
                            this.$route.name == "batch_main"
                                ? this.$route.params.projectCode
                                : this.$store.state.examInfo.currentExamInfo
                                      .domain
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.$store.commit("setCertType", data.body.data);
                        this.CertTypes = data.body.data;
                    }
                });
        } else {
            this.CertTypes = this.$store.state.common.certType;
        }
    },
    methods: {
        getStringSite: function(list, string) {
            let num = -1;
            list.forEach((item, index) => {
                if (item.value == string) {
                    num = index;
                }
            });
            return num;
        },
        postUserInform: function() {
            if (this.activeName == 1) {
                this.$refs.form1.validate(valid => {
                    if (valid) {
                        this.$refs.form3.validate(valid => {
                            if (valid) {
                                this.$http
                                    .post(
                                        globalProvider.serviceUrl(
                                            "ea/cmp/uinf"
                                        ),
                                        {
                                            //                                        ac: this.form1.account,
                                            pwd: this.form1.pwd,
                                            c_pwd: this.form1.c_pwd,
                                            name: this.form3.name,
                                            ct: this.form3.t_ct,
                                            ci: this.form3.ct,
                                            group:this.batchCode?"BATCH":"PROJECT"
                                        }
                                    )
                                    .then(data => {
                                        if (
                                            data.body.code == resultCode.Success
                                        ) {
                                            this.setType();
                                        } else if (
                                            data.body.code ==
                                            resultCode.NotSuccess
                                        ) {
                                            this.error_display = true;
                                            this.error_message = getErrorMessage(
                                                data.body.message
                                            );
                                        }
                                    });
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            } else {
                this.$refs.form2.validate(valid => {
                    if (valid) {
                        this.$refs.form3.validate(valid => {
                            if (valid) {
                                this.$http
                                    .post(globalProvider.serviceUrl("ea/b/u"), {
                                        ac: this.form2.account,
                                        pwd: this.form2.pwd,
                                        name: this.form3.name,
                                        ct: this.form3.t_ct,
                                        ci: this.form3.ct
                                    })
                                    .then(data => {
                                        if (
                                            data.body.code == resultCode.Success
                                        ) {
                                            this.setType();
                                        } else if (
                                            data.body.code ==
                                            resultCode.NotSuccess
                                        ) {
                                            this.error_display = true;
                                            this.error_message = getErrorMessage(
                                                data.body.message
                                            );
                                        }
                                    });
                            } else {
                                return false;
                            }
                        });
                    } else {
                        return false;
                    }
                });
            }
        },
        setType() {
            let n = this.$store.state.common.userType;
            n.token = this.$store.state.common.token;
            n.if_bind_user = true;
            this.$store.commit("setUserType", n);
            this.myResult = false;
        }
    }
};
</script>
